import axiosInstance from "../utils/axios";
import { getCmsPageType } from "../utils/cmsHelpers";

export type PageType = "terms_conditions" | "about_us" | "privacy_policy" | "how_to_play" | "contact_us";

export interface CMSPage {
  _id: string;
  pageType: PageType;
  title: string;
  content: string;
  createdBy?: {
    _id: string;
    full_name: string;
    email: string;
  };
  updatedBy?: {
    _id: string;
    full_name: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface CMSResponse {
  status: number;
  message: string;
  data: CMSPage;
}

export const getCmsPagesAPI = async (): Promise<CMSResponse> => {
  try {
    const response = await axiosInstance.get(`/api/user/cms`);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching CMS pages:", error);
    throw new Error(error.response?.data?.message || "Failed to fetch CMS pages");
  }
};

export const getCmsPageByTypeAPI = async (pageType: string): Promise<CMSResponse> => {
  try {
    const backendPageType = getCmsPageType(pageType);

    const response = await axiosInstance.get(`/api/user/cms/${backendPageType}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error fetching CMS page ${pageType}:`, error);
    throw new Error(error.response?.data?.message || `Failed to fetch ${pageType} page`);
  }
};

export const getSocialMediaListAPI = async () => {
  try {
    const response = await axiosInstance.get(`/api/user/social-media/list`);
    if (!response.data.status) {
      throw new Error(response.data.message);
    }
    return response.data;
  } catch (error: any) {
    console.error("Error fetching social media list:", error);
    throw new Error(error.response?.data?.message || "Failed to fetch social media list");
  }
};
